import { render } from "./ChannelCreation.vue?vue&type=template&id=a78f45a8"
import script from "./ChannelCreation.vue?vue&type=script&lang=js"
export * from "./ChannelCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__